import { Component, AfterContentInit, OnDestroy, ElementRef } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { AudMessageDTO, AudMessageFilterDTO } from '../../api/plyca-dtos-v2';
import { PaginationInfo, PaginationDTO } from '../../api/PaginationModel';
import { UserService } from '../../user.service';
import { FieldConfig } from '../../api/contract-notice-dto';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { TranslateService } from '@ngx-translate/core';
import { AppConfiguration } from '../../conf/app.configuration';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { catchError, finalize } from 'rxjs/operators';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { EMPTY, Observable } from 'rxjs';


@Component({
  selector: 'eventViewerPanel',
  templateUrl: 'eventViewerPanel.template.html'
})
export class eventViewerPanelComponent extends BaseComponent
  implements AfterContentInit, OnDestroy {
  loaded = false;
  messages: AudMessageDTO[] = [];
  filters: AudMessageFilterDTO;
  public FROM_PARAM = 'from';
  public TO_PARAM = 'to';
  public ACTIONTYPE_PARAM = 'actionType';
  public MESSAGETYPE_PARAM = 'messageType';
  public USER_PARAM = 'user';
  public DOSSIER_PARAM = 'dossierId';
  public DOCUMENTCLASS_PARAM = 'documentClassId';
  public DIVISION_PARAM = 'division';
  public ORDERNUMBER_PARAM = 'orderNumber';
  public events: AudMessageDTO[] = [];
  configurations: Array<any> = [];
  public pageInfo: PaginationInfo;
  orderColumns: any[] = [];
  primeCols = [];
  primeColOrden = -1;
  protected appConfig: AppConfiguration;
  editing = false;

  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    public userService: UserService,
    public translateService: TranslateService,
    private plycaErrorHandler: PlycaErrorHandler,
    private waitService: WaitLoadingService
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.AUDIT));
    this.initPageValues();
    // Listas de los combos:
    this.configurations['messageType'] = [
      {
        'label': 'REQUEST',
        'value': 'REQUEST'
      },
      {
        'label': 'RESPONSE',
        'value': 'RESPONSE'
      }
    ];
  }


  ngAfterContentInit(): void {

    this.headerActionsService.setTaskDescription(
      this.elem, 'EventViewer.title', 'far fa-eye', true);
    this.headerActionsService.addDivider();
    this.subscribe(
      this.headerActionsService.addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ), success => {
        this.uiService.routeBack();
      });
    this.filters = new AudMessageFilterDTO();
    let date = new Date();
    date.setDate(date.getDate() - 7);
    this.filters.size = 100;
    this.filters.from = date;
    this.filters.user = this.userService.getUser();
    this.search(true);
  }

  ngOnDestroy(): void { }

  public isLoaded(): boolean {
    return this.loaded;
  }

  public search(pageChange: Boolean) {
    this.loaded = false;
    this.subscribe(
      this.plycaService
        .getEventViewer(this.filters2string(pageChange))
      , (result: PaginationDTO<AudMessageDTO>) => {
        if (result && result.content) {
          this.pageInfo = result.page;
          this.events = result.content;
          this.dtoToModel();
        } else {
          this.events = [];
        }
        this.loaded = true;
      });
  }

  dtoToModel() {
    this.events.map(
      (event) => {
        if (event != null) {
          if (event.division != null && event.division.identifier != null) {
            let n = event.division.identifier.indexOf('<');
            let lotId: string = event.division.identifier.substring(0, n);
            event.lotId = lotId;
          }

          let text = '';

          let have = false;

          if (event.division != null && event.division.project != null && event.division.project.identifier != null) {
            text += event.division.project.identifier;
            have = true;
          }
          text += ';';
          if (event.documentClass != null && event.documentClass.identifier != null) {
            text += event.documentClass.identifier;
            have = true;
          }
          text += ';';
          if (event.orderNumber != null) {
            text += event.orderNumber;
            have = true;
          }
          text += ';';
          if (event.lotId != null && event.lotId !== 'nulo') {
            text += event.lotId;
            have = true;
          }
          text += ';';

          if (!have) {
            text = '';
          }

          event.documentDescription = text;

          text = '';

          if (event.user != null) {
            if (event.user.identifier != null) {
              text += '[' + event.user.identifier + '] ';
            }
            if (event.user.person != null && event.user.person.fullName != null) {
              text += event.user.person.fullName;
            }
          }
          event.userDescription = text;
        }
        return event
      }
    )
  }

  private filters2string(pageChange: Boolean): string {
    let filterStr = '';

    if (this.filters.from) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'dateFrom=' + this.filters.from.getTime();
    }
    if (this.filters.to) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'dateTo=' + this.filters.to.getTime();
    }

    if (this.filters.user) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'user=' + this.filters.user.identifier;
    }

    if (this.filters.messageType) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'messageType=' + this.filters.messageType;
    }

    if (this.filters.actionType) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'actionType=' + this.filters.actionType;
    }

    if (this.filters.dossierId) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'dossierId=' + this.filters.dossierId;
    }

    if (this.filters.documentClassId) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'documentClassId=' + this.filters.documentClassId;
    }

    if (this.filters.orderNumber != null) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'orderNumber=' + this.filters.orderNumber;
    }

    if (this.filters.division != null) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'division=' + this.filters.division;
    }

    let pageSize = 25;
    let page = 0;
    if (pageChange) {
      pageSize = this.pageInfo.size;
      page = this.pageInfo.number;
    }

    filterStr += '&size=' + pageSize + '&page=' + page + this.getOrderColumnsParams();


    console.log('FILTROS!!', filterStr);
    return filterStr;
  }

  public getFieldConfig(name: string): FieldConfig {
    let config = new FieldConfig();
    config.fieldStyle = 'col-12';
    config.jsonField = name;
    if (name === this.FROM_PARAM) {
      config.type = 'DATETIME';
      config.description = 'Fecha desde:';
    } else if (name === this.TO_PARAM) {
      config.type = 'DATETIME';
      config.description = 'Fecha hasta:';
    } else if (name === this.ACTIONTYPE_PARAM) {
      config.type = 'STRING';
      config.description = 'Tipo Acción:';
    } else if (name === this.MESSAGETYPE_PARAM) {
      config.type = 'DROPDOWN';
      config.description = 'Tipo Mensaje:';
      config.dropDownDataKey = 'message';
      config.data = this.configurations['messageType'];
    } else if (name === this.USER_PARAM) {
      config.type = 'SEARCH';
      config.description = 'Usuario';
      config.idBuscador = 'com.nexusit.framework.buscador.interfaz.BuscadorUsuarios';
      config.autoSearch = false;
    } else if (name === this.DOSSIER_PARAM) {
      config.type = 'STRING';
      config.description = 'Propuesta:';
    } else if (name === this.DOCUMENTCLASS_PARAM) {
      config.type = 'STRING';
      config.description = 'Listadoc:';
    } else if (name === this.DIVISION_PARAM) {
      config.type = 'INTEGER';
      config.description = 'Lote:';
      config.maxlength = 3;
    } else if (name === this.ORDERNUMBER_PARAM) {
      config.type = 'INTEGER';
      config.description = 'Número de orden:';
      config.maxlength = 3;
    }
    return config;
  }

  getOrderColumnsParams(): string {
    console.log(this.orderColumns);
    let orderParams = '';
    let desc = '';
    if (this.orderColumns.length === 1 && this.primeColOrden === 1) {
      desc = ',desc';
    }
    this.orderColumns.forEach((ordenElement) => {
      orderParams += '&sort=' + ordenElement.code + desc;

    })
    console.log(orderParams);

    return orderParams;
  }

  reloadEvents(event: any) {
    this.pageInfo.number = event.page;
    this.pageInfo.size = event.rows;
    this.load();
  }

  load(): void {
    this.waitService.startWaiting();
    this.editing = true;
    this.search(true);
    this.normalizeDivisionsIdentifiers();
    this.loaded = true;
    this.waitService.cancelWaiting();
  }

  normalizeDivisionsIdentifiers() {
    if (this.events != null) {
      this.events.forEach((event: AudMessageDTO) => {
        if (event != null && event.division != null && event.division.identifier != null) {
          let n = event.division.identifier.indexOf('<');
          let lotId: string = event.division.identifier.substring(0, n);
          event.lotId = lotId;
        }
      });
    }
  }

  initPageValues(): void {
    this.pageInfo = new PaginationInfo();
    this.pageInfo.size = 25;
    this.pageInfo.number = 0;
  }

  viewDocument(event: AudMessageDTO) {
    if (event != null && event.identifier != null) {
      // this.subscribe(this.plycaService.viewDocument(event.identifier));
      let nameFile = event?.audFileMessage?.file?.identifier;
      let extensionFile = this.getFileExtension(nameFile);
      this.subscribe(this.plycaService.viewDocumentAudMessage(event.identifier, event.audFileMessage.messageType, extensionFile).pipe(
        catchError((error: any) => this.manageError(error)),
        finalize(() => this.load())
      ));
    }
  }

  getFileExtension(fileName: string): string {
    
    const dotIndex = fileName.lastIndexOf('.');
    
    if (dotIndex === -1 || dotIndex === fileName.length - 1) {
      return null;
    }
    
    const extension = fileName.substring(dotIndex);

    return extension;
  }

  private manageError(error: any): Observable<any> {
    this.waitService.cancelWaiting();
    this.plycaErrorHandler.showServerError(error);
    return EMPTY;
  }
}
